import React, { useState, useContext } from 'react';
import ReactPaginate from 'react-paginate';
import Header from '../components/Header';
import { TravelsContext } from "../Api/Travels";
import CardProject from '../components/CardProject';
import Search from '../components/Search';
import Footer from '../components/Footer';

function Projects() {
  const { travels } = useContext(TravelsContext);

  const [currentPage, setCurrentPage] = useState(0); // react-paginate uses 0-based index
  const itemsPerPage = 9;

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = travels.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(travels.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <>
      <Header />
      <div className='project-page first-section'>
        <div className='container'>
          <Search />
          <div className='grid-style'>
            {currentItems.map((travel) => (
              <CardProject travel={travel} key={travel._id} />
            ))}
          </div>

          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={'pagination-buttons'}
            activeClassName={'active buttons-pagination'}
            previousClassName={'button-toggle'}
            nextClassName={'button-toggle'}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Projects;
